import MenuContextProvider from "../../context/menu-context";
import PageContainer from "../../components/PageContainer";
import HeaderOne from "../../components/header-one";
import React from "react";
import ArtistImage from "../../components/artistImage";
import ArtistMenu from "../../components/artistMenu";
import ArtistSummary from "../../components/artistSummary"
import ArtistMediaPlayer from "../../components/artistMediaPlayer";
import FeaturedAlbums from "../../components/featuredAlbums";
import ArtistMusicVideoSlider from "../../components/artistMusicVideoSlider";
import Footer from "../../components/footer";
import ContactArtist from "../../components/contactArtist";
import SocialMediaBanner from "../../components/socialMediaBanner";
import sundayMorning from "../../assets/images/releases/sundayMorning.png";
import vaporDreams from "../../assets/images/releases/vaporDreams.png";
import SummaryImage from "../../assets/images/whiptrip6/summaryImage.jpg";
import backgroundImage from "../../assets/images/bg/whiptrip6.png";
import videoSliderGif1 from "../../assets/gifs/vaporDreams.gif";
import videoSliderGif2 from "../../assets/gifs/pod3.gif";

class WhipTrip extends React.Component {
    state = {
        artist: "whiptrip6",
        artistRealName: "David Counter",
        artistEmail: "whiptrip6@halfhousestudios.com",
        backgroundImage: backgroundImage,
        artistNameLink: "whiptrip6",
        SummaryImage: SummaryImage,
        spotifyArtistLink: "https://open.spotify.com/embed/artist/13v0fOzWzB0XdbyzczOgjG?utm_source=generator&theme=0",
        artistSummaryP1: "WhipTRip6 is a founding member of Half House Studios, a cooperative organization created to host a safe and hi-fi recording space for local artists. " +
            "He has a long history of music involvement, from playing drums in his school jazz band to having a rock band in high school which he had toured with at the time. ",
        artistSummaryP2: "After graduating from the University of Illinois in 2020, WhipTrip created the idea for Half House Studios with the help of Mousepad and other local artists Half House was able to blossom into the organization it is today.",
        artistPageMenu: [
            {
                name: "Releases",
                url: "#releases"
            },
            {
                name: "Videos",
                url: "#videos",
            },
            {
                name: "Contact",
                url: "#contact"
            }
        ],
        index: 0,
        mainSlideOptions: {
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: "#main-slider-next",
                prevEl: "#main-slider-prev"
            }
        },
        socialMedia: [
            {
                name: "Twitter",
                url: "https://twitter.com/whiptrip6"
            },
            {
                name: "Instagram",
                url: "https://www.instagram.com/whiptrip6/"
            },
            {
                name: "SoundCloud",
                url: "https://soundcloud.com/whiptrip6"
            }
        ]
    }
    render() {
        return (
            <MenuContextProvider>
                <PageContainer >
                    <HeaderOne/>
                    <ArtistImage bgImage={this.state.backgroundImage} artist={this.state.artist}/>
                    <ArtistMenu data={this.state}/>
                    <SocialMediaBanner data={this.state.socialMedia} />
                    <ArtistSummary data={this.state}/>
                    <ArtistMediaPlayer data={this.state}/>
                    <FeaturedAlbums data={this.state}/>
                    <ArtistMusicVideoSlider data={this.state}/>
                    <ContactArtist artist={this.state.artist} artistEmail={this.state.artistEmail} />
                    <Footer />
                </PageContainer>
            </MenuContextProvider>
        )
    }
}
export default WhipTrip;